module.exports = __webpack_public_path__ + "static/media/item_5_23_comp.9371591b.png";